/* @flow */
import PropTypes from "prop-types";

import React from "react";
import _ from "lodash";

/**
 * Shows an internationalized message. Pass the message ID as k.
 */
class Msg extends React.Component<{
    [x: string]: any;
}> {
    static propTypes = {
        k: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
        className: PropTypes.string
    };

    static contextTypes = {
        intl: PropTypes.object
    };

    render() {
        let kString;
        if (Array.isArray(this.props.k)) {
            kString = this.props.k.join(".") || "";
        } else {
            kString = this.props.k || "";
        }
        let text = kString;
        const args = _.omit(this.props, "k", "className");
        try {
            if (!_.isEmpty(args)) {
                text = this.context.intl.formatMessage({ id: kString }, args);
            } else {
                text = this.context.intl.formatMessage({ id: kString });
            }
        } catch (e) {
            console.warn("Message key not found", kString, e);
        }
        return <span className={this.props.className}>{text}</span>;
    }
}

export default Msg;
